import Link from 'next/link';

import Text from '@/v2/components/Typography/Text';
import Colors from '@/v2/constants/Colors';
import useCurrentUser from '@/v2/domains/Auth/hooks/useCurrentUser.hook';
import EmailVerificationCard from '@/v2/domains/Auth/components/EmailVerificationCard/EmailVerificationCard';
import ResendVerificationEmailButton from '@/v2/domains/Auth/components/ResendVerificationEmailButton/ResendVerificationEmailButton';
import emailVerificationConstants from '@/v2/domains/Auth/constants/emailVerificationConstants';
import useUnlockWhenEmailVerified from '@/v2/domains/Auth/hooks/useUnlockWhenEmailVerified.hook';

export default function CheckInbox() {
  const { user } = useCurrentUser();

  useUnlockWhenEmailVerified();

  return (
    <EmailVerificationCard
      title="Check your inbox"
      descriptionLines={[
        <>
          We sent a verification link to <strong>{user?.email}</strong>.
        </>,
        'Open it on any device to start your free trial.',
      ]}
      secondaryAction={
        <Link href={emailVerificationConstants.logoutPath}>
          <Text variant="grey-16-medium" color={Colors.BLUE}>
            Log out
          </Text>
        </Link>
      }
    >
      <Text
        variant="dm-14-regular"
        color={Colors.NEUTRAL_VARIANTS[90]}
        align="center"
      >
        Didn't get the email? Check your spam folder or send it again.
      </Text>
      <ResendVerificationEmailButton />
    </EmailVerificationCard>
  );
}
